export { default } from '@/features/dashboard/forms/pages/New'
